import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { ehrPlatformData } from '__mocks__/mockData/ehr-data';

const EhrApi = [
  rest.post(`${API_ROOT}ehr?action=send`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.get(`${API_ROOT}ehr-platforms`, (req, res, ctx) => {
    const all = req.url.searchParams.get('all');
    if (all === 'true') {
      return res(ctx.json(ehrPlatformData));
    }
    return res(
      ctx.json({
        limit: 0,
        skip: 0,
        total: 0,
        data: [],
      }),
    );
  }),
];
export default EhrApi;
